import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const RSE = () => {
  const sectorData = {
    title: "RSE",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Prestataires RSE, cabinets ESG ou solutions de mesure d'impact doivent convaincre des décideurs souvent débordés. Proposer un diagnostic environnemental, des benchmarks sectoriels ou des contenus à forte valeur ajoutée permet de créer l'adhésion en amont.",
    name: "RSE",
    titleContext: "des acteurs de la RSE",
    responseContext: "des acteurs de la RSE",
    expertContext: "des acteurs du monde de la RSE"
  };

  return <SectorPage sector={sectorData} />;
};

export default RSE; 